module.exports = __webpack_public_path__ + "static/media/preview_icn.95adb4a4.png";